export default "__VITE_ASSET__CXAWVny2__"